import { ValueOf } from './value-of';

export const SEX = {
  MALE: 'male',
  FEMALE: 'female',
  PREFER_TO_NOT_ANSWER: 'prefer_not_to_answer',
} as const;

export type Sex = ValueOf<typeof SEX>;
